import { createContext, Dispatch, SetStateAction } from "react";
import SweetScroll from "sweet-scroll";

interface MainContext {
  isLoaderExited: boolean;
  setLoaderExited: Dispatch<SetStateAction<boolean>>;
  isLoading: boolean;
  setLoading: Dispatch<SetStateAction<boolean>>;
  scroller: SweetScroll | null;
  isOpen: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export const MainContext = createContext<MainContext>({
  isLoaderExited: false,
  setLoaderExited: () => {},
  isLoading: true,
  setLoading: () => {},
  scroller: null,
  isOpen: false,
  setOpen: () => {},
});
